export enum ProcesoResultado {
  ERROR = "ERROR",
  WARNING = "WARNING",
  SUCCESS = "SUCCESS"
}

export default interface ContactCenterResumen {
  idUser: number;
  numeroEmpleado: number;
  empleadoNombre: string;
  esSupervisor: boolean;
  esEmpleadoNuevo: boolean;

  metaCitas: number;
  citasCaptadas: number;
  descuentoSanciones: number;
  citasAlcance: number;
  citaComision: number;
  citaComisionTotal: number;

  metaConversion: number;
  integrantes: number;
  ventas: number;
  reactivacion: number;
  conversiones: number;
  conversionAlcance: number;
  bonoAplicable: boolean;
  conversionBono: number;

  subtotalComision: number;
  totalComision: number;
  descripcion: string;
  mensaje: string;
  resultado: ProcesoResultado;
}
